import { render, staticRenderFns } from "./all_result.vue?vue&type=template&id=642e93a0&scoped=true&"
import script from "./all_result.vue?vue&type=script&lang=js&"
export * from "./all_result.vue?vue&type=script&lang=js&"
import style0 from "./all_result.vue?vue&type=style&index=0&id=642e93a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e93a0",
  null
  
)

component.options.__file = "all_result.vue"
export default component.exports